var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0724 4.67917C40.8315 3.77476 40.3616 2.95024 39.7094 2.28771C39.0573 1.62519 38.2457 1.14777 37.3554 0.903C34.0962 0 20.9787 0 20.9787 0C20.9787 0 7.86059 0.0273333 4.60133 0.930333C3.71104 1.17512 2.89942 1.65256 2.24727 2.31512C1.59512 2.97768 1.12521 3.80223 0.884328 4.70667C-0.101523 10.5897 -0.483953 19.554 0.911399 25.2017C1.1523 26.1061 1.62223 26.9306 2.27437 27.5931C2.92652 28.2556 3.73813 28.7331 4.6284 28.9778C7.88766 29.8808 21.0054 29.8808 21.0054 29.8808C21.0054 29.8808 34.1231 29.8808 37.3822 28.9778C38.2725 28.7331 39.0841 28.2557 39.7363 27.5932C40.3885 26.9306 40.8584 26.1061 41.0993 25.2017C42.1392 19.3103 42.4596 10.3515 41.0724 4.67917Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8037 21.3434L27.6856 14.9404L16.8037 8.53735V21.3434Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosYoutubeIcon);
export default __webpack_public_path__ + "static/media/logos_youtube_icon.571f3688333fbc233dcf909f3333f8bf.svg";
export { ForwardRef as ReactComponent };